import { render, staticRenderFns } from "./login-forgotten-password.html?vue&type=template&id=4603fede&"
import script from "./LoginForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./LoginForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports